export const initialState = {
    isLoading: false,
    selectedService: null,
    appointmentsForService: null,
    appointments: null,
    pinnedAppointments: [],
    unPinnedAppointments:[],
    selectedAppointment: null,
    apptSuccessMsg: null,
    apptErrorMsg: null,
    appointmentsForUser: null,
    currentPageNumber: 0,
    newAppointmentCount: [],
    roomsNotificationCount: [],
    apptUnreadCount: [],
    sortAscending: false,
};

export const AppointmentsReducer = (state = initialState, action) => {
    switch(action.type){
        case 'field': {
            return {
                ...state,
                [action.fieldName]: action.payload,
            };
        }
        case 'selectServiceForAppointments': {
            console.log('=== APPOINTMENTS REDUCER DEBUG ===');
            console.log('selectServiceForAppointments action received with payload:', action.payload);
            console.log('Previous selectedService:', state.selectedService);
            console.log('=== END REDUCER DEBUG ===');
            return {
                ...state,
                selectedService: action.payload,
            };
        }
        case 'setAppointmentsForService': {
            return {
                ...state,
                appointmentsForService: action.payload,
            };
        }
        case 'selectAppointment': {
            return {
                ...state,
                selectedAppointment : action.payload,
            }
        }
        case 'setPinnedAppointments': {
            return {
                ...state,
                pinnedAppointments : action.payload,
            }
        }
        case 'setUnPinnedAppointments': {
            return {
                ...state,
                unPinnedAppointments : action.payload,
            }
        }
        case 'apptSubmitSuccess': {
            return{
                ...state,
                apptSuccessMsg: "Appointment Request has been submitted successfully",
                apptErrorMsg: null
            }
        }
        case 'apptSubmitError': {
            return{
                ...state,
                apptSuccessMsg: null,
                apptErrorMsg: action.payload,
            }
        }
        case 'clearMessage': {
            return {
                ...state,
                apptSuccessMsg: "",
                apptErrorMsg: ""
            }
        }
        case 'setAppointmentsForUser': {
            return {
                ...state,
                appointmentsForUser: action.payload,
            }
        }
        case 'setAppointments': {
            return {
                ...state,
                appointments: action.payload,
            }
        }
        case 'setCurrentPageNumber':{
            return {
                ...state,
                currentPageNumber: action.payload,
            }
        }
        case 'setAppointmentCountForService':{
            return {
                ...state,
                newAppointmentCount: action.payload,
            }
        }
        case 'setRoomsNotifications':{
            // If payload is a single notification object, increment the count for that room
            if (action.payload && !Array.isArray(action.payload) && action.payload.roomKey) {
                const currentNotifications = state.roomsNotificationCount || [];
                const existingRoom = currentNotifications.find(n => n.roomKey === action.payload.roomKey);
                
                if (existingRoom) {
                    // Increment existing room count
                    const updatedNotifications = currentNotifications.map(n => 
                        n.roomKey === action.payload.roomKey 
                            ? { ...n, notificationCount: n.notificationCount + action.payload.notificationCount }
                            : n
                    );
                    return {
                        ...state,
                        roomsNotificationCount: updatedNotifications,
                    };
                } else {
                    // Add new room notification
                    return {
                        ...state,
                        roomsNotificationCount: [...currentNotifications, action.payload],
                    };
                }
            }
            // For arrays (periodic sync), preserve manually cleared counts (0)
            const currentNotifications = state.roomsNotificationCount || [];
            const newNotifications = action.payload || [];
            
            // Preserve rooms that have been manually cleared to 0
            const mergedNotifications = newNotifications.map(newRoom => {
                const existingRoom = currentNotifications.find(n => n.roomKey === newRoom.roomKey);
                // If existing room was manually cleared to 0, keep it at 0
                if (existingRoom && existingRoom.notificationCount === 0) {
                    return { ...newRoom, notificationCount: 0 };
                }
                return newRoom;
            });
            
            return {
                ...state,
                roomsNotificationCount: mergedNotifications,
            };
        }
        case 'clearRoomNotifications':{
            // Clear notifications for a specific room
            const currentNotifications = state.roomsNotificationCount || [];
            const updatedNotifications = currentNotifications.map(n => 
                n.roomKey === action.payload 
                    ? { ...n, notificationCount: 0 }
                    : n
            );
            return {
                ...state,
                roomsNotificationCount: updatedNotifications,
            };
        }
        case 'setApptUnreadCount': {
            return {
                ...state,
                apptUnreadCount: action.payload,
            }
        }
        case 'setSortAscending': {
            return {
                ...state,
                sortAscending: action.payload,
            }
        }
        case 'logout': {
            return {
                ...state,
                selectedService: null,
                appointmentsForService: null,
                appointments: null,
                pinnedAppointments: [],
                unPinnedAppointments:[],
                selectedAppointment: null,
                apptSuccessMsg: null,
                apptErrorMsg: null,
                appointmentsForUser: null,
                newAppointmentCount: [],
                roomsNotificationCount: [],
                setApptUnreadCount: [],
            }
        }
        default: 
            return state

    }


}